/*eslint-disable*/
import api from '../'

class TrainerStageApi {

    static show(id) {
        return api.axios.get('/olympiad/trainer-stage/' + id)
            .then(response => response.data.stage);
    }

    static update(id, params) {
        return api.axios.put('/olympiad/trainer-stage/' + id, params)
            .then(response => response.data.stage);
    }
}

export default TrainerStageApi;
